import { Component, OnInit, Inject } from '@angular/core';
import { AlertService } from "src/app/share/service/alert.service";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { FileUploaderDataService } from './services/file-uploader-data.service';
import { VouchersDataService } from 'src/app/vouchers/_services/vouchers-data.service';

@Component({
  selector: 'app-file-uploader-popup',
  templateUrl: './file-uploader-popup.component.html',
  styleUrls: ['./file-uploader-popup.component.scss']
})
export class FileUploaderPopupComponent implements OnInit {

  //#region Properties

  uploaderTitle: string = "File Uploader"
  uploadedFile: any;
  serviceType: string;
  selectedPartnerId: number | null = null;
  externalVoucherPartnerList: any;

  private allowedMIMEType: string[] = [];
  private allowedFileType: string[] = [];
  private allowedFileExtensions: string[] = [];   
  //#endregion

  constructor(
    private alertService: AlertService,
    private bottomSheetRef: MatBottomSheetRef<FileUploaderPopupComponent>,
    private fileUploaderDataService: FileUploaderDataService,
    private vouchersDataService: VouchersDataService,
    @Inject(MAT_BOTTOM_SHEET_DATA)
    private data: {
      title: string;
      serviceType: string;
      isAllowExcel: boolean;
    }
  ) {
    this.uploaderTitle = this.data.title;
    this.serviceType = this.data.serviceType;

    this.configureAllowedFileTypes();

    if (this.data.serviceType == "External Vouchers") {
      this.getExternalVoucherPartnerList();
    }
  }

  //#region Lifecycles

  ngOnInit(): void {
  }

  //#endregion

  //#region Event Handlers

  onFileChange(e) {
    // Future Enhancements:
    //  - enable controls for single/multi files upload feature
    if (e.target.files && e.target.files[0]) {
      const file: File = e.target.files[0];

      if (this.isValidFileType(file)) {
        this.uploadedFile = file;
      }
    }

    e.target.value = "";
  }

  onFileDelete() {
    this.uploadedFile = null;
  }

  onFileUpload() {
    if (this.data.serviceType == "Cash Vouchers") {
      // Handle Cash Vouchers Uploads
      this.uploadCashVouchers();
    }
    else if (this.data.serviceType == "External Vouchers") {
      // Handle Cash Vouchers Uploads
      this.uploadExternalVouchers();
    }
  }

  onPopupClose(event: MouseEvent): void {
    this.bottomSheetRef.dismiss();
    event.preventDefault();
  }

  //#endregion

  //#region Public Methods

  getAllowedFileExtensions() {
    return this.allowedFileExtensions.join(", ");
  }

  //#endregion

  //#region Private Methods

  private configureAllowedFileTypes() {
    // Excel Files
    if (this.data.isAllowExcel) {
      this.allowedMIMEType.push(
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      );
      this.allowedFileType.push("Excel");
      this.allowedFileExtensions.push(".xls", ".xlsx");
    }
  }

  private isValidFileType(file: File): boolean {
    let isValid = this.allowedMIMEType.includes(file.type);

    if (!isValid) {
      this.alertService.openSnackBar("Only allowed to upload " + this.allowedFileType.join(", ") + " files.");
    }

    return isValid;
  }

  // For CRM > Vouchers > Cash Vouchers module

  private uploadCashVouchers(){
    const formData = new FormData();
    formData.append("File", this.uploadedFile);

    this.fileUploaderDataService.uploadCashVoucherExcel(formData).subscribe(
      (x) => {
        this.alertService.openSnackBar(this.uploadedFile.name + " uploaded successfully.");

        this.bottomSheetRef.dismiss({ success: true });
      },
      (err) => {
        console.error("File upload error:", err);
        this.alertService.openSnackBar("File upload failed.");
      }
    );
  }

  //#endregion

  // For CRM > Vouchers > External Vouchers module
  
  private uploadExternalVouchers(){
    const formData = new FormData();
    formData.append("File", this.uploadedFile);

    this.fileUploaderDataService.uploadExternalVoucherExcel(formData, this.selectedPartnerId).subscribe(
      (x) => {
        this.alertService.openSnackBar(this.uploadedFile.name + " uploaded successfully.");

        this.bottomSheetRef.dismiss({ success: true });
      },
      (err) => {
        console.error("File upload error:", err);
        this.alertService.openSnackBar("File upload failed.");
      }
    );
  }

  private getExternalVoucherPartnerList() {
    this.vouchersDataService.getExternalVoucherPartnerListing().subscribe({
      next: (x) => {
        this.externalVoucherPartnerList = x;
      },
      error: (err) => {
        this.alertService.openSnackBar(err.error);
      }
    });
  }
  

  //#endregion

}
